import AnnouncementModal from './AnnouncementModal';
import variants from './variants';
import types from './types';

export { variants, types };

export default AnnouncementModal;
